import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';


@Injectable()
export class PatientService {
    private baseUrl = environment.apibaseUrl;
    public timezoneoffset = new Date().getTimezoneOffset();

    constructor(private http: HttpClient, public datepipe: DatePipe) { }

    public getPatients(patient: string, clinic: number, status: any = '') {
        return this.http.get(this.baseUrl + '/patient/list?patient=' + patient + '&clinic=' + clinic + '&status=' + status);
    }

    public savePatient(user: any) {
        return this.http.post(this.baseUrl + '/patient/', user);
    }

    public saveAnonymousPatient(user: any) {
        return this.http.post(this.baseUrl + '/patient/saveAnonymousPatient/', user);
    }

    public getPatient(patientId) {
        return this.http.get(this.baseUrl + '/patient/PatientDetails?id=' + patientId + '&timezoneoffset=' + this.timezoneoffset);
    }

    public getClinics() {
        return this.http.get(this.baseUrl + '/clinician/clinics');
    }

    public loadClinicians(clinicId: number) {
        return this.http.get(this.baseUrl + '/clinician/list?clinicId=' + clinicId);
    }

    public helpNow(helpInfo) {
        return this.http.post(this.baseUrl + '/patient/HelpNow', helpInfo);
    }

    public connectPatient(helpInfo) {
        helpInfo.timezoneoffset=this.timezoneoffset;
        return this.http.post(this.baseUrl + '/patient/ConnectPatient?appointmentId=' + helpInfo.appointmentId, helpInfo);
    }

    public connectPatientWaitingRoom(patientId, clinicianId, waitingRoomId) {
        return this.http.get(this.baseUrl + '/patient/ConnectPatientWaitingRoom?patientId=' + patientId + '&clinicianId=' + clinicianId + '&waitingRoomId=' + waitingRoomId);
    }

    public reconnectPatientWaitingRoom(patientId, clinicianId, waitingRoomId, sessionId, dbsessionId) {
        return this.http.get(this.baseUrl + '/patient/ReconnectPatientWaitingRoom?patientId=' + patientId + '&clinicianId=' + clinicianId + '&waitingRoomId=' + waitingRoomId + '&tokenId=' + sessionId + '&dbSessionId=' + dbsessionId);
    }

    public reconnectClinicianWaitingRoom(clinicianId, waitingRoomId, sessionId, dbsessionId, latitude, longitude) {
        return this.http.post(this.baseUrl + '/patient/Reconnect/Clinician/WaitingRoom?waitingRoomId=' + waitingRoomId +
         '&clinicianId=' + clinicianId + '&sessionId=' + sessionId + '&dbSessionId=' + dbsessionId, {
            Latitude: latitude,
            Longitude: longitude
        });
    }

    public patientConnected(zipcode, county, sessionId, clinicianId) {
        return this.http.get(this.baseUrl + '/patient/PatientConnected?zipcode=' + zipcode +
         '&county=' + county + '&sessionId=' + sessionId + '&clinicianId=' + clinicianId);
    }

    public patientDeclinedAppointment(patientId, clinicianId) {
        return this.http.get(this.baseUrl + '/patient/PatientDeclined-Appointment?patientId=' + patientId + '&clinicianId=' + clinicianId);
    }

    public clinicianSnoozeAppointment(patientId) {
        return this.http.get(this.baseUrl + '/patient/ClinicianSnooze-Appointment?patientId=' + patientId);
    }

    public handleEmergency(id: string) {
        return this.http.post(this.baseUrl + '/patient/HandleEmergency?id=' + id, null);
    }

    public deletePatient(id: number) {
        const loginTime = this.datepipe.transform(new Date(), 'yyyy-MM-ddTHH:mm');
        return this.http.delete(this.baseUrl + '/patient/?userid=' + id + '&loginTime=' + loginTime);
    }

    public ValidCasesAvailabelwithPatient(id: number) {
        return this.http.get(this.baseUrl + '/patient/case/casesavailable/?userid=' + id);
    }

    public getPatientNote(id: number) {
        return this.http.get(this.baseUrl + '/patient/note/?userid=' + id);
    }

    public getPatientNoteByPatientId(id: number) {
        return this.http.get(this.baseUrl + '/patient/patientNote/?patientId=' + id);
    }

    public getUserContactInfo(zipcode: string, county: string) {
        const info: any = {
            ZipCode: zipcode,
            County: county
        };
        return this.http.post(this.baseUrl + '/patient/ContactInfo', info);
    }

    public getPatientInfo(id: number, date: any, appointmentId: number) {
        return this.http.get(this.baseUrl + '/patient/PatientInfo/?id=' + id + '&datetime=' + date + '&appointmentId=' + appointmentId + '&timezoneoffset=' + this.timezoneoffset);
    }

    public sendSecretCode(code: any, uniqueId: any) {
        return this.http.get(this.baseUrl + '/patient/sendSecretCode/?uniqueId=' + uniqueId + '&secretCode=' + code);
    }

    public insertSession(session: any, isHelpNow = false) {
        session.isHelpNow = isHelpNow;
        return this.http.post(this.baseUrl + '/patient/createsession', session);
    }

    public updateEndtime(sessionId: number) {
        return this.http.post(this.baseUrl + '/patient/updateendtime', {
            SessionId: sessionId
        });
    }

    public getSessionDurationDetails(s_id: number, date: any, appointmentId: number) {
        return this.http.get(this.baseUrl + '/patient/sessionDuration/?s_id=' + s_id +
         '&datetime=' + date + '&appointmentId=' + appointmentId + '&timezoneoffset=' + this.timezoneoffset);
    }

    public insertNotes(notes: any) {
        return this.http.post(this.baseUrl + '/patient/insertnotes', notes);
    }

    public updateNotes(notes: any) {
        return this.http.post(this.baseUrl + '/patient/updatenotes', notes);
    }

    public updateNotesAfterRegister(data: any) {
        return this.http.post(this.baseUrl + '/patient/updatenotesregister', data);
    }

    public connectToClinician(clinicianId: number, uniqueId: string, sessionId) {
        const info: any = {
            Clinician: clinicianId,
            UniqueId: uniqueId,
            SessionId: sessionId
        };
        return this.http.post(this.baseUrl + '/patient/invitation', info);
    }

    public updateInvitation(connectionId: string, tokenId: string) {
        const info: any = {
            connectionId: connectionId,
            token_id: tokenId
        };
        return this.http.post(this.baseUrl + '/patient/update-invitation', info);
    }

    public getanonymousId(code: string) {
        return this.http.get(this.baseUrl + '/patient/anonymousid/?code=' + code);
    }

    sendInvitation(info) {
        return this.http.post(this.baseUrl + '/patient/send-invitation', info);
    }

    listOfInvitedClients(s_id) {
        return this.http.get(this.baseUrl + '/patient/invitationList/?s_id=' + s_id);
    }

    public validatetoken(token) {
        return this.http.get(this.baseUrl + '/patient/validation/?token=' + token);
    }

    // checking

    public CheckUnmappedClinicswithAppointments(userId, clinics) {
        const info: any = {
            ApportisUserId: userId,
            Clinics: clinics,
        };
        return this.http.post(this.baseUrl + '/user/CheckUnmappedClinicswithAppointments', info);
    }

    public CheckUnmappedClinicianwithAppointments(userId, clinicianIds) {
        const info: any = {
            ApportisUserId: userId,
            Clinicians: clinicianIds,
        };
        return this.http.post(this.baseUrl + '/user/CheckUnmappedClinicianwithAppointments', info);
    }

    public getExportData(patient: string, clinic: number, status: string) {
        // return this.http.get(this.baseUrl + '/patient/exportlist?patient=' + patient + '&clinic=' + clinic);
        return this.http.get(this.baseUrl + '/patient/exportlist?patient=' + patient + '&clinic=' + clinic + '&status=' + status);
    }

    public updateUserSessiontoExpired(sessionId: number) {
        return this.http.post(this.baseUrl + '/patient/sessionExpired', {
            SessionId: sessionId
        });
    }

    public updateInviteUserSessiontoExpired(token: string) {
        return this.http.post(this.baseUrl + '/patient/inviteUserTokenExpired', {
            Token: token
        });
    }

    public updateSessiontoCompleted(sessionId: number) {
        return this.http.post(this.baseUrl + '/patient/updateSessiontoCompleted', {
            SessionId: sessionId
        });
    }

    public emailCheck(email) {
        return this.http.post(this.baseUrl + '/patient/emailCheck', email);
    }

    getCaseList(waitingRoomId: number, patient_id: number, s_id: number) {
        return this.http.get(this.baseUrl + '/patient/Caselist?wrid=' + waitingRoomId + '&clientId=' + patient_id + '&sId=' + s_id);
    }

    saveCaseNotes(noteInfo) {
        return this.http.post(this.baseUrl + '/patient/createcasenote', noteInfo);
    }

    caseNoteList(caseIds, appoinmentId, WaitingRoomId, sessionId) {
        return this.http.post(this.baseUrl + '/patient/SavedNotesList', {
            CaseIds: caseIds,
            AppointmentId: appoinmentId,
            WaitingRoomId: WaitingRoomId,
            SessionId: sessionId
        });
    }

    caseNotebyParticipant(patient_id: number) {
        return this.http.get(this.baseUrl + '/patient/caseNotebyParticipant?patientId=' + patient_id);
    }

    public clinicianDisconnected(patient_id: number, sessionId: number = 0, isAppointment: boolean = false) {
        return this.http.get(this.baseUrl + '/patient/clinician/disconnect?patientId=' + patient_id + '&sessionId=' + sessionId + '&isAppointment=' + isAppointment);
    }

    public clientDisconnected(clinicianId: number, sessionId: number = 0, isAppointment: boolean = false) {
        return this.http.get(this.baseUrl + '/patient/client/disconnect?clinicianId=' + clinicianId + '&sessionId=' + sessionId + '&isAppointment=' + isAppointment);
    }

    public meetingDisconnected(s_id: number, patient_id: number) {
        return this.http.get(this.baseUrl + '/patient/meeting/disconnect?sessionId=' + s_id + '&clientId=' + patient_id);
    }

    public getReconnectToAppointmentByClinician(patientId: number, appointmentId: number, sessionId: string, dbSessionId: string) {
        return this.http.get(this.baseUrl + '/patient/ReconnectPatientAppointment?patientId=' +
         patientId + '&appointmentId=' + appointmentId + '&sessionId=' + sessionId + '&dbSessionId=' + dbSessionId + '&timezoneoffset=' + this.timezoneoffset);
    }

    public getReconnectToAppointmentByClient(clinicianId: number, appointmentId: number, sessionId: string, dbSessionId: string, lat, lng) {
        return this.http.post(this.baseUrl + '/patient/ReconnectClinicianAppointment?clinicianId=' + clinicianId +
         '&appointmentId=' + appointmentId + '&sessionId=' + sessionId + '&dbSessionId=' + dbSessionId+ '&timezoneoffset=' + this.timezoneoffset, {
            Latitude: lat,
            Longitude: lng
        });
    }

    public noResponseFromClinician(clientId, isAppointment) {
        return this.http.get(this.baseUrl + '/patient/clinician/noresponse?clientId=' + clientId + '&isAppointment=' + isAppointment);
    }

    public noResponseFromClient(clinicianId, isAppointment) {
        return this.http.get(this.baseUrl + '/patient/client/noresponse?clinicianId=' + clinicianId + '&isAppointment=' + isAppointment);
    }

    onclosedevent(userId, isClient, dbsessionId) {
        fetch(this.baseUrl + '/patient/unRregisterUser?userId=' + userId + '&isClient=' + isClient + '&sessionId=' + dbsessionId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            keepalive: true
        });
    }

    public getSocialWorkersList(clinicIds) {
        return this.http.post(this.baseUrl + '/patient/socialworker/list',clinicIds );
    }
}
